import { combineReducers, configureStore } from "@reduxjs/toolkit";
import generalReducer from "../slices/generalSlice";
import serviceBookingsReducer from "../slices/serviceBookingsSlice";
import userReducer from "../slices/userSlice";
import fileUploadsReducer from "../slices/ordersHistorySlice";
import ordersSliceReducer from "../slices/ordersListingSlice";
import brandSliceReducer from "../slices/brandListingSlice";
import brandDetailsSliceReducer from "../slices/brandSlice";
import statusListingSliceReducer from "../slices/statusListingSlice";
import dateSliceReducer from "../slices/dateSlice";
import statusSliceReducer from "../slices/statusSlice";

const rootReducer = combineReducers({
  general: generalReducer,
  serviceBookings: serviceBookingsReducer,
  user: userReducer,
  fileUploads: fileUploadsReducer,
  orders: ordersSliceReducer,
  brands: brandSliceReducer,
  brand: brandDetailsSliceReducer,
  statusListing: statusListingSliceReducer,
  status: statusSliceReducer,
  date: dateSliceReducer,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
